<template>
    <div class="overall-bg p-0">
        <b-container>
            <!-- <b-row v-if="tstatus == true">

                <b-col>
                    <BacktoPage path="/Masters"></BacktoPage>
                    <Headerlayout :headertext="$t('Supppliers.SupppliersMaster.Master')"
                        :contenttext="$t('Supppliers.SupppliersMaster.content')">
                    </Headerlayout>
                </b-col>
            </b-row> -->

            <b-row class="py-5">
                <Loader :loading="loading" />
                <div v-if="!loading">
                    <MasterEmpty v-if="items.length === 0" eheader="Outbound Issue" econtent="Outbound Issue"
                        eimg="/src/assets/Img/icons/itemmaster.svg" @createNew="" />
                    <Tableview v-if="items.length !== 0" :value="items" :paginator="true" class="p-datatable-gridlines"
                        :rows="10" :rowHover="true" filterDisplay="menu" :loading="loading1" responsiveLayout="scroll"
                        :columns="headers" :globalFilterFields="globalFilterFields" :filters="filters"
                        selectionMode="single" @row-click="RowClick">
                        <!-- <template v-slot:Add>
                        <span>
                            <AddButton @click="IsCreate()" :btnname=" $t('btn.plusaddnew')" class="float-rights my-3"></AddButton> -->
                        <!-- <DeliveryTermsCreation :showButton="true" @close="deliverytermstable()" /> -->
                        <!-- </span>
                    </template> -->
                        <template v-slot:action="{ data }">
                            <span>
                                <EditIcon @click="Editdata(data)" />
                                <DeleteIcon @click="Deletedata(data)" />
                            </span>
                        </template>
                    </Tableview>
                </div>
            </b-row>

            <DeletedSuccessfully :visible="deletepop" @ok="deletepop = false" />
            <DeleteConfirmationVue :DeleteModel="Deletemodel" @yes="IsDelete()" @no="Deletemodel = false" />
            <EditConfirmation :Editmodel="Editmodel" @yes="IsEdit()" @no="Editmodel = false"
                :content="$t('confirmation.editcontent')" />
        </b-container>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, h, onMounted, computed } from "vue";
import Headerlayout from "../../../../../components/Masters/HeaderLayout.vue";
import BacktoPage from "../../../../../components/FormComponents/BacktoMaster.vue";

import PaymentCreation from "../../../../../modules/Inventory/pages/Masters/Supplier/PaymentTerms/PaymentTermsCreation.vue";
import { RouterLink, RouterView, useRouter } from "vue-router";


import service from "../../../../../modules/Inventory/Service/SupplierMaster";
import Table from "../../../../../components/FormComponents/Table.vue";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import Tableview from "../../../../../components/FormComponents/Table.vue";
import { useI18n } from 'vue-i18n';
import CategoryCreation from "../../../../../modules/Inventory/pages/Masters/ItemCategory/CategoryMaster/CategoryCreation.vue";
import EditConfirmation from "../../../../../components/FormComponents/EditConfirmation.vue";
import DeleteConfirmationVue from "../../../../../components/FormComponents/DeleteConfirmation.vue";
import DeletedSuccessfully from "../../../../../components/FormComponents/DeletedSuccessfully.vue";
import SupplierCategoryMappingService from '../../../../../modules/Inventory/Service/SupplierCategoryMappingService'
import MasterEmpty from "../../../../../components/Masters/MasterEmpty.vue";
import Loader from '../../../../../components/FormComponents/Loader.vue'
export default defineComponent({
    components: {
        BacktoPage,
        Headerlayout,
        PaymentCreation,


        Table,
        CategoryCreation,
        Tableview,
        DeletedSuccessfully,
        EditConfirmation,
        DeleteConfirmationVue,
        MasterEmpty,
        Loader
    },
    props: {
        tstatus: {
            default: true,
            type: Boolean
        }
    },
    setup() {
        onMounted(() => {
            IsShow();
        });
        const Editmodel = ref(false);
        const { t } = useI18n();
        const router = useRouter();
        const generic = ref();

        let loading1 = ref(false);
        let loading = ref(false);

        //Loading
        let supplierid = 0;

        const deletepop = ref(false);
        const Deletemodel = ref(false);

        function Editdata(data) {
            supplierid = data.Id;
            Editmodel.value = true;
        }

        function Deletedata(data) {
            supplierid = data.Id;
            Deletemodel.value = true;
        }

        // filters for datatable

        const items = ref([]);

        const filters = {
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            Name: { value: null, matchMode: FilterMatchMode.IN, options: items },
            SupplierCategory: {
                value: null,
                matchMode: FilterMatchMode.IN,
                options: items,
            },
        };

        const headers = [
            {
                header: "Supplier ID",
                field: "Code",
            },
            {
                header: "Supplier Name",
                field: "Name",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                bodyclass: 'boldclass',

            },
            // {
            //     header: "Supplier Category",
            //     field: "SupplierCategory",
            //     filterTemplate: "MultiSelect",
            //     ShowMactchMode: false,
            // },
            // {
            //     field: "action", header: "Action", slot: "action",
            //     frozencolumn: true, sortable: false
            // },
        ];

        const filteredColumns = computed(() => {
            return headers.filter((col) => col.field !== "id");
        });

        const globalFilterFields = ref(headers.map((col) => col.field));

        // add new button function

        const IsCreate = () => {
            router.push({
                path: "/SupplierMasterCreation",
            });
        };

        // edit button function

        function IsEdit() {
            router.push({
                path: "/SupplierMasterCreation",
                query: {
                    Id: supplierid,
                },
            });
        }

        // row click for table

        function RowClick(event: any) {
            // console.log(event.data)
            debugger;

            // rowFocus.value = true;
            // Editmodel.value = true;
            // supplierid = event.data.Id;
            router.push({
                path: '/SupplierMasterDetailsView'
            })
        }

        //Get data for table

        async function IsShow() {
            debugger;
            try {
                loading.value = true
                const response = await service.gettable();
                console.log(response["result"]);
                items.value = response["result"];
                console.log(items.value);
                loading.value = false

            } catch (error) {
                console.log(error);
            }
        }

        //Delete Values in Table

        const IsDelete = async () => {
            try {
                const response = await service.deletedata(supplierid);
                Deletemodel.value = false;
                IsShow();
                deletepop.value = true;
            } catch (error) {
                console.log(error);
            }
        };

        const dataEdit = ref();
        const rowFocus = ref(false);
        const showDialog = ref();

        function onKeyUp(event: any) {
            debugger;

            console.log(dataEdit.value);
            if (
                (event.key == "e" ||
                    (Editmodel.value == false && event.key == "Enter")) &&
                rowFocus.value == true &&
                Deletemodel.value == false
            ) {
                // IsEdit(dataEdit.value)
                Editmodel.value = true;
            } else if (
                event.altKey &&
                event.key == "n" &&
                Editmodel.value == false &&
                Deletemodel.value == false
            ) {
                IsCreate();
            } else if (
                (event.key == "y" || event.key == "Enter") &&
                Deletemodel.value == true &&
                Editmodel.value == false &&
                rowFocus.value == true
            ) {
                IsDelete();
            } else if (
                (event.key == "y" || event.key == "Enter") &&
                Editmodel.value == true &&
                rowFocus.value == true
            ) {
                IsEdit();
            } else if (
                event.key == "n" &&
                rowFocus.value == true &&
                Editmodel.value == true
            ) {
                Editmodel.value = false;
            } else if (
                event.key == "d" &&
                rowFocus.value == true &&
                Editmodel.value == false
            ) {
                Deletemodel.value = true;
                Editmodel.value = false;
            } else if (
                event.key == "n" &&
                rowFocus.value == true &&
                Deletemodel.value == true
            ) {
                Deletemodel.value = false;
            } else if (event.key == "Escape" && deletepop.value == true) {
                deletepop.value = false;
            } else if (event.key == "Enter" && rowFocus.value == false) {
                Editmodel.value = false;
            }
        }

        onMounted(() => {
            debugger;
            document.addEventListener("keydown", onKeyUp);
        });

        return {
            deletepop,
            headers,
            items,
            IsShow,
            IsDelete,
            generic,
            loading1,
            loading,
            globalFilterFields,
            filters,
            IsCreate,
            IsEdit,
            Editdata,
            Editmodel,
            Deletedata,
            RowClick,
            Deletemodel,
        };
    },
});
</script>
